import { staticEntityReducerTemplate } from '../reducerUtils';

export default staticEntityReducerTemplate('categories');



// WEBPACK FOOTER //
// ./src/reducers/entities/categoriesReducer.js